import { takeLatest, put, call, takeEvery } from 'redux-saga/effects';
import get from 'lodash/get';
import { getRentals as rentalsList, getRentalsAggregations as rentalsAggregationsList } from '../../utils/API';
import { getRentals, getRentalsAggregations } from './actions';

export function* getRentalsRequest({ payload }) {
  try {
    const response = yield call(rentalsList, payload);
    yield put(getRentals.success(response));
  } catch (err) {
    yield put(getRentals.failure(err.message));
  } finally {
    yield put(getRentals.fulfill());
  }
}

export function* getRentalsAggregationsRequest({ payload }) {
  try {
    const response = yield call(rentalsAggregationsList, payload);
    yield put(getRentalsAggregations.success(get(response, 'data')));
  } catch (err) {
    yield put(getRentalsAggregations.failure({ type: payload.type, message: err.message }));
  } finally {
    yield put(getRentalsAggregations.fulfill());
  }
}

export default function* rentalsSaga() {
  yield takeLatest(getRentals.TRIGGER, getRentalsRequest);
  yield takeEvery(getRentalsAggregations.TRIGGER, getRentalsAggregationsRequest);
}
